import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import type { StaffNotification } from '@fitness-force/models';
import { environment } from '@fitness-force/environments';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { catchError, map, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StaffNotificationService {
  private http = inject(HttpClient);


  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  getNotifications(): Observable<StaffNotification> {
    return this.http.get(`${environment.BASE_URL}${CONST_URL_SEGEMENTS.STAFF.STAFF_NOTIFICATIONS}`, this.httpOptions).pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  patchNotifications(request: any): Observable<any> {
    return this.http.patch(`${environment.BASE_URL}${CONST_URL_SEGEMENTS.STAFF.STAFF_NOTIFICATIONS}`,request,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getStaffNotifications(): Observable<any> {
    return this.http.get(environment.BASE_URL + CONST_URL_SEGEMENTS.STAFF.GET_STAFF_NOTIFICATIONS,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markNotificationAsRead(tenantId:number, payload:any ): Observable<any> {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.STAFF.MARK_STAFF_NOTIFICATION_AS_READ
      .replace('{tenant_id}', tenantId.toString()),payload,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markNotificationAsDelete(tenantId:number, id:number): Observable<any> {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.STAFF.MARK_STAFF_NOTIFICATION_AS_DELETE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{notification_id}', id.toString()),this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

}
